/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The confirmation mode for the tool variation
 */
export const Confirm = {
  Always: "always",
  Never: "never",
  Session: "session",
} as const;
/**
 * The confirmation mode for the tool variation
 */
export type Confirm = ClosedEnum<typeof Confirm>;

export type UpsertGlobalToolVariationForm = {
  /**
   * The confirmation mode for the tool variation
   */
  confirm?: Confirm | undefined;
  /**
   * The confirmation prompt for the tool variation
   */
  confirmPrompt?: string | undefined;
  /**
   * The description of the tool variation
   */
  description?: string | undefined;
  /**
   * Override: if true, the tool may perform destructive updates
   */
  destructiveHint?: boolean | undefined;
  /**
   * Override: if true, repeated calls have no additional effect
   */
  idempotentHint?: boolean | undefined;
  /**
   * The name of the tool variation
   */
  name?: string | undefined;
  /**
   * Override: if true, the tool interacts with external entities
   */
  openWorldHint?: boolean | undefined;
  /**
   * Override: if true, the tool does not modify its environment
   */
  readOnlyHint?: boolean | undefined;
  /**
   * The name of the source tool
   */
  srcToolName: string;
  /**
   * The URN of the source tool
   */
  srcToolUrn: string;
  /**
   * The summarizer of the tool variation
   */
  summarizer?: string | undefined;
  /**
   * The summary of the tool variation
   */
  summary?: string | undefined;
  /**
   * The tags of the tool variation
   */
  tags?: Array<string> | undefined;
  /**
   * Display name override for the tool
   */
  title?: string | undefined;
};

/** @internal */
export const Confirm$outboundSchema: z.ZodMiniEnum<typeof Confirm> = z.enum(
  Confirm,
);

/** @internal */
export type UpsertGlobalToolVariationForm$Outbound = {
  confirm?: string | undefined;
  confirm_prompt?: string | undefined;
  description?: string | undefined;
  destructive_hint?: boolean | undefined;
  idempotent_hint?: boolean | undefined;
  name?: string | undefined;
  open_world_hint?: boolean | undefined;
  read_only_hint?: boolean | undefined;
  src_tool_name: string;
  src_tool_urn: string;
  summarizer?: string | undefined;
  summary?: string | undefined;
  tags?: Array<string> | undefined;
  title?: string | undefined;
};

/** @internal */
export const UpsertGlobalToolVariationForm$outboundSchema: z.ZodMiniType<
  UpsertGlobalToolVariationForm$Outbound,
  UpsertGlobalToolVariationForm
> = z.pipe(
  z.object({
    confirm: z.optional(Confirm$outboundSchema),
    confirmPrompt: z.optional(z.string()),
    description: z.optional(z.string()),
    destructiveHint: z.optional(z.boolean()),
    idempotentHint: z.optional(z.boolean()),
    name: z.optional(z.string()),
    openWorldHint: z.optional(z.boolean()),
    readOnlyHint: z.optional(z.boolean()),
    srcToolName: z.string(),
    srcToolUrn: z.string(),
    summarizer: z.optional(z.string()),
    summary: z.optional(z.string()),
    tags: z.optional(z.array(z.string())),
    title: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      confirmPrompt: "confirm_prompt",
      destructiveHint: "destructive_hint",
      idempotentHint: "idempotent_hint",
      openWorldHint: "open_world_hint",
      readOnlyHint: "read_only_hint",
      srcToolName: "src_tool_name",
      srcToolUrn: "src_tool_urn",
    });
  }),
);

export function upsertGlobalToolVariationFormToJSON(
  upsertGlobalToolVariationForm: UpsertGlobalToolVariationForm,
): string {
  return JSON.stringify(
    UpsertGlobalToolVariationForm$outboundSchema.parse(
      upsertGlobalToolVariationForm,
    ),
  );
}
